export default "__VITE_ASSET__CHFhMyCM__"